// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3sD7o","additionalInfo":"AgreementModal_additionalInfo__1vchK"};